import { KYMW9002Model } from '../kymw9002.model';
import { UserInformationDetailModel } from '../vo/user-information-detail.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ユーザー登録用メソッド
 *
 * @export API通信成功時の処理
 * @class RegistUserService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistUserService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9002Model;
  private successFunc: Function;
  private vo: UserInformationDetailModel;

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistUserService
   */
  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * CWSアイコンマスタ取得
   *
   * @param vo:CWSアイコンマスタ取得用VO
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        UserManagement: {
          condition: {
            UserID: this.vo.userId,
            UserPassword: this.vo.userPassword,
            AuthoritySetID: this.vo.authoritySetID,
            UserName: this.vo.name,
            Section: this.vo.section,
            Memo: this.vo.memo,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9002Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof RegistUserService
   */
  execute(model: KYMW9002Model, vo: UserInformationDetailModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registUser', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistUserService
   */
  success(data: any) {
    // 親画面を再表示する
    this.model.kymw9002Component.refleshParent();
  }

}
